import { indent, angleType, colonType } from '../../helpers'

export const moduleTemplate = ({
    rootSelector,
    type,
    isTypeScript,
    className,
    elementProperties,
    elementClasses,
    rootReference,
    elementReferences,
    autoGeneratedDisclaimer,
    prefix = '',
    suffix = ''
}: {
    rootSelector: string
    type: string
    isTypeScript: boolean
    className: string
    elementProperties: string
    elementClasses: string
    rootReference: string
    elementReferences: string
    autoGeneratedDisclaimer: string
    prefix?: string
    suffix?: string
}) =>
    `/* ${autoGeneratedDisclaimer} */

${prefix}

import { BemPlusModule } from '@bem-plus/class-generator/module'
${elementClasses}
export class ${className} extends BemPlusModule {
    root;

    static selector = '${rootSelector}';

    ${indent(elementProperties, 1)}
    constructor(rootElement${colonType('Element', isTypeScript)}) {
        super(${angleType(type, isTypeScript)}rootElement)

        ${rootReference}

        this.refresh()
    }

    refresh = () => {
        ${indent(elementReferences, 2)}
    }
}

${suffix}
`
